// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import sponsor css modules
import sponsorStyles from '../sponsorModuleStyles.css';

function SponsorListItem({ sponsor }) {
  return (
    <div className="yt-col full _50">
      <div className="form-container -slim sponsor-item-wrapper">
        <img src={sponsor.logo ? sponsor.logo : "/img/yt_logo.png"} height="75" />
        <h2> {sponsor.name} </h2>
        <div className="yt-row space-between">
          <div className="yt-col">
            <Link className="yt-btn small success" to={`/sponsors/${sponsor._id}/my-studies`}>SELECT</Link>
          </div>
        </div>
      </div>
    </div>
  )
}

SponsorListItem.propTypes = {
  sponsor: PropTypes.object.isRequired
}

export default SponsorListItem;



// WEBPACK FOOTER //
// modules/sponsor/components/SponsorListItem.js.jsx